import { HeightMap } from "../../core/height-map";
import { EarthBrainUtils } from "../../utilities/earthbrainutility";
/**
 * A single spreading/compaction result mesh in LOCAL coordinates.
 * Pure data + trace. No display state.
 * WGS84 conversion for Cesium rendering is handled by SpreadingCompaction.
 */
export class SpreadingCompactionGeometry {
    _geometry;
    _heightMap;
    _type;
    _offset;
    constructor(geometry, type, offset) {
        this._geometry = geometry;
        this._heightMap = HeightMap.FromIndexedGeometry(this._geometry, Number.MAX_SAFE_INTEGER);
        this._type = type;
        this._offset = offset;
    }
    get geometry() {
        return this._geometry;
    }
    get heightMap() {
        return this._heightMap;
    }
    get type() {
        return this._type;
    }
    get offset() {
        return this._offset;
    }
    tracePoints(points) {
        return EarthBrainUtils.tracePointsOnGeometry(this._geometry, this._heightMap, points);
    }
}
//# sourceMappingURL=spreading-compaction-geometry.js.map